import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  nfeController: [
    'runtimeConstant',
    '$scope',
    'service',
    '$rootScope',
    '$filter',
    'authService',
    '$uibModal',
    'EAdminFeatures',
    function (
      runtimeConstant,
      $scope,
      service,
      $rootScope,
      $filter,
      authService,
      $uibModal,
      EAdminFeatures
    ) {
      'use strict';

      function init() {
        $scope.listCompanies();
        //$scope.sort($scope.sortColumns);
      }

      function listCompanies() {
        $scope.items = null;
        $scope.loading = false;

        service.getList().then(
          function () {
            $scope.items = service.list();
            for (var i = 0; i < $scope.items.length; i++) {
              $scope.items[i].Cnpj = $scope.items[i].Cnpj.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                '$1.$2.$3/$4-$5'
              );
            }

            $scope.loading = false;
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
            $scope.loading = false;
          }
        );
      }

      function alertUpdateList() {
        $scope.list();
      }

      function certified() {
        $scope.newMediaModal = $uibModal.open({
          templateUrl: '/views/partials/loadCertified.html',
          controller: 'nfeModalController',
          resolve: {
            service2: 'nfeService',
          },
        });
      }

      function newCompany() {
        $scope.newMediaModal = $uibModal.open({
          templateUrl: '/views/partials/newCompany.html',
          controller: 'nfeModalController',
          resolve: {
            service2: 'nfeService',
          },
        });
      }

      function loadNfe() {
        $scope.loading = false;
        var companies = $scope.items;
        for (var i = 0; i < companies.length; i++) {
          service.SearchForNfe(companies[i]);
        }
      }

      function loadOneNfe(company) {
        $scope.loading = false;
        service.SearchForNfe(company);
      }

      function remove(id) {
        service.Remove(id).then(
          function () {
            $scope.loading = false;
            swal.fire(' ', ' Filial Removida com Exito!');

            $scope.listCompanies();
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
            $scope.loading = false;
          }
        );
      }

      function run() {
        try {
          $rootScope.menus = [
            {
              // FAZER A LISTAGEM NO SIDEBAR
              title: 'MODULE.NFES',
              icon: 'md md-description',
              ref: 'modules.nfe.nfes',
              visible: function () {
                return authService.isSysAdmin();
              },
              features: [EAdminFeatures.ManageNFes],
              enabled: true,
            },
          ];

          $scope.isSysAdmin = authService.isSysAdmin();

          $scope.items = [];

          $scope.newNfeModal = null;
          $scope.sortColumns = service.sortColumns();
          $scope.loading = false;
          $scope.sortingColumn = null;

          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.listCompanies = logWrapper(
            listCompanies,
            runtimeConstant.isDebugControllersInternals
          );
          $rootScope.alertUpdateList = logWrapper(
            alertUpdateList,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.certified = logWrapper(
            certified,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newCompany = logWrapper(
            newCompany,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadNfe = logWrapper(
            loadNfe,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadOneNfe = logWrapper(
            loadOneNfe,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.remove = logWrapper(
            remove,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
